import type { HydraGetSubscriptionItem } from '@/lib/services/Hydra/account/GET/getSubscriptions'

type Props = {
  subscription: HydraGetSubscriptionItem
}

export const getSubscriptionNextShippingDate = ({ subscription }: Props) => {
  if (!subscription.recurrence.dateNext) {
    return null
  }

  const date = new Date(subscription.recurrence.dateNext)

  const monthName = date.toLocaleString('default', {
    month: 'long',
    timeZone: 'UTC',
  })

  return `${monthName} ${subscription.recurrence.schedule.dayOfMonth}`
}
